import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from "@/config/bwmodel";
// import h5Share from "@/utils/h5Share";
import bg1 from "./images/Slice12@2x.png";
import bg2 from "./images/Slice13@2x.png";
import AvatarWall from "./AvatarWall";
// import BirthdayFireworks from "./BirthdayFireworks";
import { fetchRecordsList, fetchBlessing } from "./api";
import { connect } from "react-redux";
import throttle from 'lodash/throttle';
import styles from "@/styles";
import bridge from '@/config/JSbridge'
import PureReactTypewriter from './PureReactTypewriter'
import Fireworks  from "./Fireworks";
import { jumpTo } from '@/utils'
import OpenApp from '@/components/OpenApp'
// 示例用法
export const isStorm = bwmodel.app === "storm";

const App = ({ userId, avatar, token }) => {
  
const avatarWallRef = React.useRef(null);
const [showFloatingImage, setShowFloatingImage] = useState(false);
const [externalAvatars, setExternalAvatars] = useState([]);

  useEffect(() => {
    getList();
  }, []);
  function getList() {
    fetchRecordsList().then((res) => {
      // console.log(res);
      setExternalAvatars(res.userList);
    });
  }
  // / 使用 useCallback + 空依赖，内部创建 throttle
  const handleAddAvatarFromOutside = useCallback(
    
    throttle(() => {
          //  setShowFloatingImage(true);
        fetchBlessing().then((res) => {
      // setExternalAvatars([...externalAvatars, ]);
       setShowFloatingImage(true);
      if (avatarWallRef.current) {
        setTimeout(() => {
           setShowFloatingImage(false);
           avatarWallRef.current.addAvatar({ avatar, userId });
        }, 3500);
      
      }
    });
    }, 2000),
    [] // 空依赖，函数永远不会重新创建
  );
  
  // 示例：在控制台可调用 window.addExternalAvatar 进行外部插入
  useEffect(() => {
    window.addExternalAvatar = handleAddAvatarFromOutside;
    return () => {
      delete window.addExternalAvatar;
    };
  }, [handleAddAvatarFromOutside]);

 const handleLogin = (cb) => {
    if(!isStorm) {
      window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
    }
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }     
  function goEidt(content) {
      // handleUploadTrace('Million_Create_Click', 'click')
      if(!token) {
        return  handleLogin()
      } 
      
       jumpTo(`storm://app/topic/detail?name=${content}`);

      // const text = content ? `#${content}#`:''
      // bridge.callHandler('nativeEvent', {
      //   event: 'openPublishForumEvent',
      //   params: {
      //     text: text,
      //     // imageBase64: str
      //   }
      // }, res => {
      // })
    }
  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {isStorm && (
          <Header
            title="市值风云十周年活动"
            hideNaviBar
            bg_color={styles.bg_color2}
            right={<img onClick={ () => {
                bridge.callHandler('nativeEvent', {
                  event: 'shareLink',
                  params: {
                    title: `市值风云十周年庆活动进行中！`,
                    desc: '会员买一送一，上祝福墙，还能领十周年纪念周边！', 
                    thumbUrl: 'https://file.wogoo.com/app/logo/logo210.jpg',
                    linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_210/code',
                  }
                })
              }
            } 
            src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          />
        )}
      <div>
        <PureReactTypewriter token={token} speed={100} delay={50} />
      </div>
      
      <Content className={isStorm? 'mt40': ''}>
        <CardBox>
          <img
            className="title"
            src={require("./images/Group_1597880792@2x.png")}
            alt=""
          />
          <div className="card">
            <p className="card_title">
              祝福墙将会打印并展示在市值风云办公室留作纪念
            </p>
            <div>
              {/* 头像地址从外部传入 externalAvatars */}
              <AvatarWall ref={avatarWallRef} avatars={externalAvatars} />
              
              <Fireworks 
                showImage={showFloatingImage}
                autoCloseDelay={4000} // 4秒后自动消失
              />
            </div>

            <img
              className="card-btn"
              src={require("./images/Group_1597880791@2x.png")}
              alt=""
              onClick={() => {
                console.log("xxxx");
                handleAddAvatarFromOutside();
              }}
            />
          </div>
        </CardBox>
        <CardBox>
          <img
            className="title"
            src={require("./images/Group_1597880790@2x.png")}
            alt=""
          />
          <div className="card">
            <div className="title1">活动规则：</div>
            <p>
              1、活动期间（2026.4.22—5.31），参与话题<span style={{'color': '#008dff'}} onClick={()=>goEidt('市值风云十周年庆')}>#市值风云十周年庆#</span>讨论，分享自己和市值风云的点点滴滴，回忆自己过去的生活学习和投资；
              <br />
              2、活动结束后，话题互动量前10的用户将获得一套市值风云十周年专属纪念周边，如下图所示。
            </p>
            <div className="imgs">
              <img src={require("./images/Group_1597880868@2x.png")} alt="" />
            </div>
            <img
              onClick={()=> {
                goEidt('市值风云十周年庆')
              }}
              className="card-btn"
              src={require("./images/Group_1597880789@2x.png")}
              alt=""
            />
          </div>
        </CardBox>
        <CardBox>
          <img
            className="title"
            src={require("./images/Group_1597880794@2x.png")}
            alt=""
          />
          <div className="card">
            <div className="title1">活动规则：</div>
            <p>
              1、活动期间（2026.4.22—5.31），在市值风云所有平台购买会员年卡（锦鲤卡/大鳄周边除外）均可享受买一送一，每个用户限一次；
              <br />
              2、活动期间，购买会员总金额1000元以上用户将获得一套市值风云十周年专属纪念周边（如上图所示），每个用户限一次。
            </p>
            <img
              className="card-btn"
              src={require("./images/Group_1000006716@2x.png")}
              alt=""
              onClick={(event)=>{
                event.stopPropagation();
                jumpTo(`storm://app/user/memberCenter`)
              }}
            />
          </div>
        </CardBox>
      </Content>
      {
        !isStorm &&  <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_210/code`}></OpenApp>
      }
    
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.user.userId,
    avatar: state.user.avatar,
    token: state.user.accessToken ,
  };
};
export default React.memo(connect(mapStateToProps)(App));
// export default App;

const Content = styled.div`
  width: 100%;
  min-height: calc(100vh);
  

  border-radius: 0px 0px 0px 0px;
  background:
    url(${bg1}) top/contain no-repeat,
    url(${bg2}) bottom/contain no-repeat;
  
  padding: 21vw 0 20vw;
  background-color: #a2060d;
  img {
    max-width: 100%;
  }
  &.mt40 {
    margin-top: 40px;
  }
`;

const CardBox = styled.div`
  margin-top: 18px;
  .title {
    display: block;
    width: 84.5vw;
    margin: 0 auto;
    margin-bottom: -11.4vw;
  }
  .card {
    margin: 0 auto;
    width: 91vw;
    height: auto;
    padding: 14.2vw 28px 21px;
    box-sizing: border-box;
    // height: 338px;
    background:
      linear-gradient(19deg, #ffe8e5 0%, #ffdcaf 7.5%, #ffffff 55%), #ffffff;
    border-radius: 16px 16px 16px 16px;
    overflow: hidden;
    // border: 1px solid;
    border-image: linear-gradient(
        358deg,
        rgba(255, 245, 229, 1),
        rgba(255, 255, 255, 0)
      )
      1 1;
  }
  .card_title {
    text-align: center;
    margin:0px  -20px;
    font-size: 12px;
    color: #320303;
  }
  .card-btn {
    display: flex;
    margin: 0 auto;
    margin-top: 12px;
    height: 10.6vw;
  }
  .title1 {
    font-size: 13px;
    color: #320303;
    font-weight: 500;
    line-height: 20px;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #320303;
    line-height: 20px;
  }
  .imgs {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    img {
      flex: 1;
      width: 30%;
      + img {
        margin-left: 5%;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/activity_210/index.js